import { render, staticRenderFns } from "./HistoryServerList.vue?vue&type=template&id=b5e32c3c&scoped=true"
import script from "./HistoryServerList.vue?vue&type=script&lang=js"
export * from "./HistoryServerList.vue?vue&type=script&lang=js"
import style0 from "./HistoryServerList.vue?vue&type=style&index=0&id=b5e32c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e32c3c",
  null
  
)

export default component.exports